import React from "react";

import { getIconRegistry, getFallbackIcon, hasIcon } from "./registry";

export interface AppIconProps {
  /** Icon name without the "Icon" prefix (e.g., "Home", "User", "Settings"). */
  iconName: string;
  /** Icon size in pixels. */
  size?: number;
  /** Icon color (CSS color value). */
  color?: string;
  /** Stroke width. */
  stroke?: number;
  /** Additional CSS class. */
  className?: string;
  /** Inline styles. */
  style?: React.CSSProperties;
}

const NoIcon: React.FC<any> = () => null;

/**
 * AppIcon — string-based icon by name from the injected registry (see
 * `configureIcons`). Unknown names fall back to the registered fallback icon
 * (or render nothing).
 */
export const AppIcon: React.FC<AppIconProps> = ({ iconName, size = 18, color, stroke = 1.5, className, style }) => {
  const IconComponent = getIconRegistry()[iconName] || getFallbackIcon() || NoIcon;

  return <IconComponent size={size} color={color} stroke={stroke} className={className} style={style} />;
};

/** Whether an icon exists in the configured registry. */
export const iconExists = (iconName: string): boolean => hasIcon(iconName);

/** All available icon names in the configured registry. */
export const getAvailableIcons = (): string[] => Object.keys(getIconRegistry()).sort();

export default AppIcon;
